<template>
    <div >
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="index-clueWrap">
            <div>
                <!-- {{callshow}} -->
    
                <div class="cluegroup-block" :style="{width:groupwidth}"></div>
                <div class="clueGroup" :style="{left:groupleft}">
                    <div class="clueGroupShow">
                        <div class="group-title">
                            <span>线索分组</span>
                        </div>
                        <a-divider />
                        <div class="group-index-wrapItems">
                            <div class="group-index-input">
                                <a-input-search v-model="searchgroupname" placeholder="搜索分组名称" @change="searchgroup" />
                            </div>
                            <div>
                                <div class="group-index-dragItems">
                                    <div class="all-item" @click="getcluebyid(0)" :class="{grouped:0==groupcurrent}">全部</div>
                                    <div class="group-item" @click="getcluebyid(item.id)" :class="{grouped:item.id==groupcurrent}" v-for="item in grouplist" :key="item.id">
                                        <div>{{item.name}}</div>
                                        <div class="group-option">
                                            <a-icon @click="editgroup(item.id)" type="form" />
                                            <a-icon @click="delgroup(item.id)" type="delete" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="index-groupNew">
                                <a-icon type="plus" />
                                <a href="javascript:;" @click="addgroupshow">新建分组</a>
                            </div>
                        </div>
                        <div class="groupNum">共<a href="javascript:;">{{groupnum}}</a>个分组</div>
                        <div class="group-index-cusIcon" v-if="sgshow" @click="sqgroup">
                            <a-icon type="left" />
                        </div>
                        <div class="group-index-cusIcon" v-if="zkshow" @click="zkgroup">
                            <a-icon type="right" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="index-tabWrp">
                <div class="clue-search">
                    <div class="sx1" :hidden="select1">
                        <div class="left" >
                            <a-select default-value="lucy" style="width: 120px" allowClear @change="handleChange" placeholder="资源范围">
                                <a-select-option value="jack">
                                    我负责的
                                </a-select-option>
                                <a-select-option value="lucy">
                                    本人及下属负责的
                                </a-select-option>
                                <a-select-option value="disabled">
                                    本部门负责的
                                </a-select-option>
                                <a-select-option value="Yiminghe">
                                    本部门及下级部门负责的
                                </a-select-option>
                                <a-select-option value="Yiminghe">
                                    全部
                                </a-select-option>
                            </a-select>

                            <div style="" v-for="(item,i) in searchlist" :key="i">
                                <a-select mode="multiple" v-if="item.field_name=='call_type'" style="width: 120px" allowClear @change="lxhandleChange" :placeholder="item.name" :showArrow="show">
                                    <a-select-option v-for="(option,x) in item.option" :key="x" :value="option">
                                        {{option}}
                                    </a-select-option>
                                </a-select>

                                <a-select mode="multiple" v-if="item.field_name=='tag'" style="width: 120px" allowClear @change="typehandleChange" :placeholder="item.name" :showArrow="show">
                                    <a-select-option v-for="(option,x) in item.option" :key="x" :value="option">
                                        {{option}}
                                    </a-select-option>
                                </a-select>

                                <a-select mode="multiple" v-if="item.field_name=='information_source'" style="width: 120px" allowClear @change="lrhandleChange" :placeholder="item.name" :showArrow="show">
                                    <a-select-option v-for="(option,x) in item.option" :key="x" :value="option">
                                        {{option}}
                                    </a-select-option>
                                </a-select>

                                <a-select mode="multiple" v-if="item.field_name=='follow_status'" style="width: 120px" allowClear @change="gjhandleChange" :placeholder="item.name" :showArrow="show">
                                    <a-select-option v-for="(option,x) in item.option" :key="x" :value="option">
                                        {{option}}
                                    </a-select-option>
                                </a-select>
                            </div>


                            <a-button icon="redo">
                            重置
                            </a-button>
                        </div>
                        <a href="javascript:;" class="right" @click="showsx">
                            <a-icon type="filter" theme="filled" />
                            高级筛选
                        </a>
                    </div>

                    <div class="sx2" :hidden="select2">
                        <div v-for="(item,i) in searchlist" :key="i">
                            <div class="sxlist" v-if="item.status==1&&item.type=='radio'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                            
                                    <span @click="rselected(item.field_name,option,option+x)" :id="item.field_name" :class="{sxed:option+x==current}" v-for="(option,x) in item.option" :key="x">{{option}}</span>
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='checkbox'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                                    <span @click="cselected(item.id+option,item.field_name,option)" v-for="(option,x) in item.option" :class="{sxed:searcharr.includes(item.id+option)}" :key="x">{{option}}</span>
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='address'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div >
                                    <a-cascader :field-names="{ label: 'name', value: 'id',children:'children'}" change-on-select  :options="addressoptions" :load-data="loadData"  placeholder="请选择企业地区（必填）" @change="onChangeaddress" />
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='datetime'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                                    <span v-for="(date,d) in datelist" :key="d" :class="{sxed:date+d==datecurrent}" @click="searchdate(item.field_name,date,date+d)">{{date}}</span>
                                    <div class="time-select">
                                        <span class="time-select-text">自定义时间段</span>
                                        <div class="time-select-hide">
                                            <a-range-picker @change="changdate($event,item.field_name)" />
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="sxlist"> 
                            <div class="sxtitle">已选条件</div>
                            <div class="sxtext">
                                <p style="display:inline" v-for="(item,i) in searchlist" :key="i">
                                    <!-- {{dxlist[item.field_name]}} -->
                                    <i v-if="dxlist[item.field_name]!=[]&&dxlist[item.field_name]">
                                        <span class="sxed"  v-for="(option,x) in dxlist[item.field_name]" :key="x">
                                            <label>{{option}}</label> 
                                            <a-icon @click="delsearch(item.id+option,item.field_name,option)" type="close" />
                                        </span>
                                    </i>
                                    
                                    <span class="sxed" v-if="xzlist[item.field_name]">
                                        <label>{{xzlist[item.field_name]}}</label> 
                                        <a-icon @click="deldxsearch(item.field_name)" type="close" />
                                    </span> 
                                </p> 
                            </div>
                        </div>

                        <div class="sxbtn">
                            <a-button @click="setxmodal" icon="setting">设置筛选选项 </a-button>
                            <a href="javascript:;" style="font-size:12px;color:#666" @click="setsx">
                                <a-icon type="filter" theme="filled"/>
                                高级筛选
                            </a>
                        </div>
                    </div>
                
                </div>

                <div class="clue-list">
                    <div class="top-tool" :hidden="cc1">
                        <div class="left">
                            <router-link to="/addclue"><a-button type="primary" icon="plus">新建</a-button></router-link> 
                            <a-button @click="importmodal" icon="download">导入</a-button>
                            <a-button @click="exportmodal" icon="upload">导出</a-button>
                            <a-button icon="file-search" @click="showcc">查重工具</a-button>
                        </div>
                        <div class="right">
                        
                            <a-input-search
                            :placeholder="tstext"
                            enter-button="查询"
                            @search="onSearch"
                            v-model="searchtext"
                            >
                                <a-select slot="addonBefore" default-value="1" style="width: 120px" 
                                @change="handleserach">
                                    <!-- <a-select-option value="jack">
                                        姓名
                                    </a-select-option> -->
                                    <a-select-option value="1">
                                        手机
                                    </a-select-option>
                                    <!-- <a-select-option value="lucy">
                                        电话
                                    </a-select-option>
                                    <a-select-option value="disabled" >
                                        微信号
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        QQ号
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        邮箱
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        公司名称
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        职位
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        公司网址
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        公司备注
                                    </a-select-option> -->
                                </a-select>
                            </a-input-search>
                            <!-- <a-button style="margin-left:15px" @click="editlist" icon="unordered-list">列表</a-button> -->
                        </div>
                    </div>

                    <div class="top-tool top-tool2" :hidden="cc2">
                        <div class="left">
                            <a-input-search
                            placeholder="请输入查重内容"
                            enter-button="查重"
                            @search="ccsearch"
                            />
                            <div>查重规则</div>
                            <a-tooltip class="rluetip">
                                <template slot="title">
                                    <p>在线索中查：手机；</p>
                                    <p>在客户中查：客户名称；</p>
                                    <p>在联系人中查：手机；</p>
                                    <p>在商机中查：客户名称、商机名称；</p>
                                </template>
                                <a-icon type="question-circle" theme="filled"/>
                            </a-tooltip>
                        </div>
                        <div class="right">
                        <a-icon type="close" @click="closecc"/>
                        </div>
                    </div>

                    <div class="top-tool top-tool3" :hidden="cc3">
                        <div class="left">
                            <a-button icon="plus">批量拨打</a-button>
                            <a-button icon="download">发送短信</a-button>
                            <a-button icon="upload">创建计划</a-button>
                            <a-button icon="build" @click="setgroupshow">设置分组</a-button>
                            <a-button icon="swap" @click="showbg">变更所属人</a-button>
                            <a-button icon="close-circle" @click="fqmodal">放弃</a-button>
                            <a-button icon="delete" @click="delmodal">删除</a-button>
                            <a-button icon="file-search" @click="plexportmodal">批量导出</a-button>
                        </div>

                    </div>
                    <a-spin :spinning="tablespinning">
                        <a-table :style="{height:tabley+'px'}" rowKey="id" :scroll="{ y: tabley,x: 2070}" :pagination="pageshow" :columns="columns" :data-source="data" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" table-layout="auto">
                        
                            <router-link slot="name" slot-scope="text,record" :to="{path:'cluedetail',query: {id:record.id}}" >
                                {{ text }}
                            </router-link>

                            <a href="javascript:;" slot="mobile_phone" slot-scope="text,record">
                                <a-popover>
                                    <template slot="content">
                                        <span class="add-black" @click="addblack($event)" :id="record.mobile_phone">+黑名单</span>
                                        <div class="phone-protect">
                                            <a-icon type="reconciliation" theme="filled" />
                                            <span>提升20%接通率？用智呼助手！</span>
                                        </div>
                                    </template>
                                    <span @click="call(record.mobile_phone,record.id)"   v-if="record.mobile_phone">
                                        {{text}} <a href="javascript:;"><a-icon type="phone" theme="filled" :rotate="90"/></a>
                                    </span>
                                </a-popover>
                            </a>
                            

                            <span slot="action" slot-scope="text, record">
                                <a-dropdown>
                                    <a class="ant-dropdown-link" @click="e => e.preventDefault()"> <a-icon type="ellipsis" :rotate="90"/>
                                    </a>
                                    <a-menu slot="overlay">
                                    <a-menu-item>
                                        <a @click="showgj($event)" :id="record.id" href="javascript:;">写跟进</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a  @click="editclue($event)" :id="record.id" href="javascript:;">编辑</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a  @click="editclue($event)" :id="record.id" href="javascript:;">创建计划</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a  @click="tokh($event)" :id="record.id" href="javascript:;">转客户</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a href="javascript:;" @click="fqmodal2(record.id)" :id="record.id">放弃</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a href="javascript:;" @click="showbg2($event)" :id="record.id">变更所属人</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a href="javascript:;" @click="delmodal2($event)" :id="record.id">删除</a>
                                    </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                                <a v-if="record.mobile_phone" @click="call(record.mobile_phone,record.id)" href="javascript:;"><a-icon type="phone" theme="filled" :rotate="90"/></a>
                            </span>
                            <!-- <a slot="name" slot-scope="text">{{ text }}</a> -->
                        </a-table>

                        <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                            <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                            <a-pagination
                            show-size-changer
                            :page-size-options="pageSizeOptions"
                            :default-current="1"
                            :total="pagination.total"
                            :defaultPageSize="10"
                            @change="handleTableChange"
                            @showSizeChange="onShowSizeChange"
                            >
                                <template slot="buildOptionText" slot-scope="props">
                                    <span>{{ props.value }}条/页</span>
                                </template>

                            </a-pagination>
                        </div>
                        
                    </a-spin>
                </div>
            </div>
        </div>
        
        

         <!-- 变更所属人 -->
        <a-modal
        title="变更所属人"
        :visible="bgvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="保存"
        >
            <div class="bgLog">
                <a-row style="margin-bottom:20px">
                   <a-col :span="5" ><label for="">现有所属人：</label></a-col>
                   <a-col :span="16">
                        <span>程先生</span>
                   </a-col>
               </a-row>
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in bglist" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

        <!-- 放弃 -->
        <a-modal
        title="放弃"
        :visible="fqvisible"
        :confirm-loading="confirmLoading"
        @ok="fqhandleOk"
        @cancel="handleCancel"
        width="520px"
        okText="确定"
        >
            <div class="fqLog">
               
               <a-row>
                   <a-col :span="5" ><label for="" class="required">放弃原因</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="fqreason">
                            <a-icon slot="suffixIcon" type="smile" />
                            <a-select-option v-for="(item,i) in reason" :key="i" :value="item">
                                {{item}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
               <div style="margin: 24px 46px 0px 92px;">
                   <span>*放弃到公海后此客户数据将属于公共资源，原归属人员不能再维护跟进和更新此客户数据。</span>
               </div>
            </div> 
        </a-modal>

        <!-- 导入数据 -->
        <a-modal
            title="批量导入"
            :visible="importvisible"
            :confirm-loading="confirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            >
            <div class="import-text">
                <svg width="27px" height="20px" viewBox="0 0 27 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="交互组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="业务组件" transform="translate(-120.000000, -1433.000000)" fill-rule="nonzero"><g id="编组-3备份-7" transform="translate(60.000000, 1301.000000)"><g id="Simple-modal备份-5" transform="translate(12.000000, 52.000000)"><g id="编组-5" transform="translate(46.000000, 76.000000)"><g id="批量导入"><rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="30" height="30"></rect><path d="M29,18.5491733 C29,20.0559059 28.4735,21.3376513 27.417125,22.4046361 C26.36075,23.4716209 25.088375,24 23.6,24 L8.301125,24 C6.56975,24 5.08475,23.3795807 3.8495,22.1319243 C2.617625,20.8876768 2,19.391171 2,17.6355889 C2,16.404977 2.327375,15.2698142 2.9855,14.2266917 C3.643625,13.1835691 4.5245,12.4029317 5.628125,11.8813704 C5.61125,11.5984319 5.59775,11.3938981 5.59775,11.2711778 C5.59775,9.26333731 6.303125,7.54866201 7.707125,6.13056076 C9.111125,4.71245952 10.80875,4 12.796625,4 C14.258,4 15.597875,4.41247656 16.8095,5.23742969 C18.021125,6.06238282 18.905375,7.15663883 19.458875,8.51678882 C20.12375,7.9270496 20.903375,7.63729334 21.791,7.63729334 C22.78325,7.63729334 23.63375,7.99181865 24.33575,8.70427817 C25.041125,9.41673769 25.392125,10.2723709 25.392125,11.2745867 C25.392125,11.993864 25.19975,12.6483723 24.815,13.2347026 C26.033375,13.5278677 27.032375,14.1687404 27.815375,15.1573206 C28.605125,16.1493097 29,17.2776547 29,18.5491733 Z M9.20225,14.9152889 C9.20225,15.0482359 9.24275,15.1573206 9.3305,15.242543 C9.414875,15.3277655 9.522875,15.3720811 9.6545,15.3720811 L12.80675,15.3720811 L12.80675,20.3695245 C12.80675,20.4922448 12.850625,20.5979206 12.938375,20.6899608 C13.026125,20.7785921 13.134125,20.8229078 13.255625,20.8229078 L15.955625,20.8229078 C16.077125,20.8229078 16.18175,20.7785921 16.272875,20.6899608 C16.364,20.6013295 16.4045,20.4922448 16.4045,20.3695245 L16.4045,15.3686722 L19.553375,15.3686722 C19.674875,15.3686722 19.7795,15.3243566 19.870625,15.2357252 C19.958375,15.1470939 20.00225,15.0380092 20.00225,14.9152889 C20.00225,14.7823419 19.96175,14.6732572 19.874,14.5880348 L14.922875,9.58718255 C14.8385,9.50196012 14.7305,9.45764445 14.598875,9.45764445 C14.46725,9.45764445 14.35925,9.49855122 14.274875,9.58718255 L9.344,14.5743992 C9.2495,14.6868928 9.20225,14.7993864 9.20225,14.9152889 L9.20225,14.9152889 Z" id="形状" fill="#4F7AFD"></path></g></g></g></g></g></g>
                </svg>
                <h3>上传填好的信息表</h3>
                <p>文件后缀名必须为xlsx,文件大小不得大于10M,最多支持导入10000条数据</p>
            </div>
            <div class="import-form">

                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button v-if="buttonshow"> <a-icon type="folder-open" /> 上传文件 </a-button>
                </a-upload>
                <a v-if="buttonshow" :href="url" download="线索导入模板.xls">下载数据模板</a>
            </div>
        </a-modal>

        <!-- 导出数据 -->
        <a-modal
            title="批量导出"
            :visible="exportvisible"
            :confirm-loading="confirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            :footer="null"
            >
            <div class="import-text">
                <a-spin :spinning="spinning">
                    <div class="export-content" >
                        <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 54px; height: 54px; margin-bottom: 12px;">
                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard-Copy-83"><circle id="Oval-12" fill="#33B028" cx="27" cy="27" r="27"></circle><polyline id="Path-9" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 28.6835304 22.5324773 37 41 19"></polyline></g></g>
                        </svg> 
                        <h4>批量导出已完成</h4>
                        <p>线索导出已完成,导出数据量{{totalnum}}条，下载导出文件。</p>
                        <a class="export-btn" :href="exporturl" download>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon-color-2"><rect id="矩形" x="0" y="0" width="20" height="20"></rect><circle id="椭圆形" fill="#4F7AFD" cx="10" cy="10" r="7"></circle><path d="M13.7874223,8.70748256 L10.6082602,6.24464133 C10.4561396,6.09636616 10.2413392,6 9.99995555,6 C9.75857185,6 9.54386039,6.09636616 9.39422917,6.24616557 L6.20991046,8.70570428 C6.08170594,8.83831359 6,9.0096218 6,9.19955966 C6,9.60729521 6.36647646,9.93788702 6.81821516,9.93788702 C6.82452759,9.93788702 6.8306622,9.93712489 6.83688572,9.93695553 L6.83688572,9.94161295 L8.66634397,9.94161295 L8.66634397,14 L11.3335671,14 L11.3335671,9.94161295 L13.1331525,9.94161295 L13.1331525,9.93568533 C13.1493336,9.93653213 13.1652481,9.93805638 13.1817848,9.93805638 C13.6336124,9.93805638 14,9.60737989 14,9.19955966 C14,9.0096218 13.9182052,8.83839827 13.7874223,8.70748256 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "></path><rect id="矩形" fill="#4F7AFD" x="8" y="7" width="4" height="1"></rect></g></g>
                            </svg>
                            <span>下载导出文件</span>
                        </a>
                    </div>
                </a-spin>
            </div>
        </a-modal>


        <!-- 列表 -->
        <a-modal v-model="visible" title="自定义显示列表" @ok="handleOk">
            <a-table
            :columns="columns2" 
            :data-source="data2"
            :pagination="false"
            rowKey='id'
            :customRow="customRow"
            bordered>
             <span slot="show">
                 <a-checkbox @change="onChange"></a-checkbox>
            </span>
            </a-table>
        </a-modal>

         <!-- 删除 -->
        <a-modal
        title="确认提示"
        :visible="delvisible"
        :confirm-loading="confirmLoading"
        @ok="delhandleOk"
        @cancel="handleCancel"
        width="420px"
        okText="确定"
        >
            <div class="delLog">
               <div>
                   <img src="../../../static/tip.png" alt="">
               </div>
               <div>是否确定删除对应的记录?</div>
            </div> 
        </a-modal>

        <!-- 写跟进 -->
        <a-modal
        title="新建跟进"
        :visible="gjvisible"
        :confirm-loading="confirmLoading"
        @ok="gjhandleOk"
        @cancel="handleCancel"
        width="610px"
        okText="保存"
        >
            <div class="followLog">
               <a-textarea v-model="gjcontent" placeholder="勤跟进,多签单" :rows="2" />
            </div>
        </a-modal>

    <!-- 拨打电话 -->
    <div class="communicate-body" v-if="callshow">
        <div>
            <div class="communicate-head">
                <a-dropdown>
                    <a class="ant-dropdown-link" >
                    <img src="../../../static/svg/drop.svg" alt="">
                    <span>五卡话机</span>
                    </a>
                    <a-menu slot="overlay">
                    <a-menu-item v-for="(item,i) in calltypelist" :key="i">{{item}}</a-menu-item>
                    </a-menu>
                </a-dropdown>

                <a-dropdown>
                    <div class="agent-status" style="width: 70px; margin-top: 1px;" >
                    SIM卡 {{currentsim}}<a-icon type="down" />
                    </div>
                    <a-menu slot="overlay"  @click="switchsim">
                    <a-menu-item v-for="(item,i) in simlist" :key="i+1" :disabled="item">
                        SIM卡{{i+1}}
                    </a-menu-item>
                    </a-menu>
                </a-dropdown>

                <div class="communicate-close"  @click="closecall">
                    <img src="../../../static/svg/close.svg" alt="">
                </div>

            </div>
        </div>

   

      <div class="communicate-body-oper">
        <div :style="{display:show1}" class="communicate-oper" id="success" >
            <div class="number-input">
                <img src="../../../static/svg/call.svg" alt="">
                <a-input autocomplete="off" v-model="phone" placeholder="请输入电话号码" style="font-size: 18px;"></a-input>
            </div>

            <div class="communicate-key">
                <div class="keyboard-box" >
                <span class="keyboard-btn" @click='handleKeyPress' data-num='1'>1</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='2'>2</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='3'>3</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='4'>4</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='5'>5</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='6'>6</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='7'>7</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='8'>8</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='9'>9</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='*'>*</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='0'>0</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='#'>#</span>
                </div>

                <div class="communicate-call-btn" >
                <!-- <a-button type="primary">了解更多</a-button> -->
                <img src="../../../static/svg/down.svg"  @click="totel" alt="">
                <img class="totell" src="../../../static/svg/callbtn.svg"  @click="totel" alt="">
                <img src="../../../static/svg/delphone.svg"  @click="totel" alt="">
                <!-- <a-button @click="totel">拨打电话</a-button> -->
                </div>
            </div>
        </div>

        <div :style="{display:show2}" class="load-communicate" id="loading">
            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

            <div class="communicate-record">
                <div class="head-top">
                    <span>{{cluedetail.clue_name}}</span>
                    <div class="labelContainer">
                        <div v-if="cluedetail.tag.length>0">--</div>
                        <div v-else class="type-list"><span v-for="(item,idx) in cluedetail.tag" :key="idx">{{item}}</span></div>
                       
                    </div>
                    <a-dropdown :trigger="['click']" v-model="typevisible">
                        <span class="ant-dropdown-link add-type" @click="e => e.preventDefault()">
                            + 标签
                        </span>
                        <div slot="overlay" class="tags-panel">
                            <div class="tags-panel-title">设置标签</div>
                             <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChangetype"
                            />

                            <div class="btnContent">
                                <a-button size="small" click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div> 
                    </a-dropdown>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="gjhandleOk">保存</a-button>
                    
                </div>
            </div>
        </div>

        <div :style="{display:show3}" class="fail-communicate-oper" id="fail" >
            <img src="../../../static/svg/fail_work.svg" alt="" >
            <h1>目前话机无法正常工作，检查后重试</h1>
            <div>
              <p>1、检测话机是否正常运作，如断电、死机</p>
              <p>2、检测话机与电脑的连接是否正常，建议重新插拔USB设备，更换USB接口或数据线</p>
            </div>
        </div>

        <div :style="{display:show4}" class="exp" id="blockpage">
            <a-spin />
        </div>
      </div>

    </div>

    <!-- 设置筛选条件 -->
    <a-modal
      title="设置筛选条件"
      :visible="vsearch"
      :confirm-loading="confirmLoading"
      @ok="setsearch"
      @cancel="handleCancel"
    >
        <div>筛选条件不得少于5项，最多支持10个筛选条件</div>
        <div>
            <div class="custom-column-head">
                <div>显示</div>
                <div>筛选项</div>
                <div>拖动调整顺序</div>
            </div>
            <vuedraggable class="custom-column">
                <transition-group>
                    <div v-for="item in searchlist" :key="item.id" class="listWrap">
                        <a-checkbox :checked="item.status==1" @change="cselect"></a-checkbox>
                        <div>{{item.name}}</div>
                        <a-icon type="pause" :rotate="90"/>
                    </div>
                </transition-group>
            </vuedraggable>
        </div>
    </a-modal>


  <!-- 新建分组 -->
    <a-modal
        title="新建分组"
        :visible="groupvisible"
        :confirm-loading="confirmLoading"
        @ok="grouphandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="确定"
        cancelText="取消"
        >
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
            <a-form-item label="分组名称">
                <a-input v-model="groupname" placeholder="请输入分组名称"/>
            </a-form-item>
            <a-form-item label="排序">
                <a-input v-model="groupsort" placeholder="请输入数字，数字越小越靠前"/>
            </a-form-item>
        </a-form>
    </a-modal>

     <!-- 编辑分组 -->
    <a-modal
        title="编辑分组"
        :visible="editgroupvisible"
        :confirm-loading="confirmLoading"
        @ok="editgrouphandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="确定"
        cancelText="取消"
        >
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
            <a-form-item label="分组名称">
                <a-input v-model="groupdetail.name" placeholder="请输入分组名称"/>
            </a-form-item>
            <a-form-item label="排序">
                <a-input v-model="groupdetail.sort" placeholder="请输入数字，数字越小越靠前"/>
            </a-form-item>
        </a-form>
    </a-modal>

    <!-- 设置分组 -->
    <a-modal
        title="设置分组"
        :visible="setgroupvisible"
        :confirm-loading="confirmLoading"
        @ok="setgroup"
        @cancel="handleCancel"
        width="510px"
        okText="确定"
        cancelText="取消"
        >
            <a-select 请选择客户分组 style="width: 100%" @change="setgroupChange">
                <a-select-option v-for="item in grouplist" :value="item.id" :key="item.id">
                    {{item.name}}
                </a-select-option>
            </a-select>
    </a-modal>

    
    </div>
</template>
<style>
::-webkit-scrollbar-thumb  {
    background: #d8d8d8 !important;
    box-shadow: none
}
::-webkit-scrollbar-track {
    background   : #fff;
     box-shadow: none
}
.ant-tooltip{
    background-color: transparent;
    box-shadow: none !important;
    background-clip: padding-box;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
}
.ant-tooltip p{
    font-size: 12px;
    color: #666;
    text-align: left;
    line-height: 20px;
}
.ant-tooltip-inner{background: #fff}
.ant-tooltip-arrow::before{background: #fff}
</style>
<script>
const columns2=[
    {
    title: '显示',
    dataIndex: 'id',
    key: 'id',
    scopedSlots: { customRender: 'show' },
  },
  {
    title: '列名',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '拖动排序',
    dataIndex: 'ly',
    key: 'ly',
  },
];

const data2 = [
  {
    id:1,
    type: 'John Brown sr.',
  },
  {
    id:2,
    type: 'Joe Black',
  },
];

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    fixed: 'left' 
  },
   {
    title: '',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'left',
    width:'30'

  },
  {
    title: '线索姓名',
    key: 'clue_name',
    dataIndex: 'clue_name',
    scopedSlots: { customRender: 'name' },
    fixed: 'left' 
  },
  {
    title: '标签',
    dataIndex: 'tag',
    key: 'tag',
    width: '120px',
  },
  {
    title: '录入方式',
    dataIndex: 'information_source',
    width: '30%',
    key: 'information_source',
    width: '150px',
  },
   {
    title: '手机',
    dataIndex: 'mobile_phone',
    key: 'mobile_phone',
    width: '160px',
    scopedSlots: { customRender: 'mobile_phone' },
  },
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: '160px',
    ellipsis: true,
  },
  {
    title: '行业',
    dataIndex: 'industry_type',
    width: '160px',
    key: 'industry_type',
    ellipsis: true,
  },
   {
    title: '所属人',
    dataIndex: 'owner',
    width: '160px',
    key: 'owner',
    ellipsis: true,
  },
  {
    title: '跟进状态',
    dataIndex: 'clue_status',
    width: '160px',
    key: 'clue_status',
    ellipsis: true,
  },
   {
    title: '最近跟进记录',
    dataIndex: 'record',
    width: '240px',
    key: 'record',
    ellipsis: true,
  },
  {
    title: '最近跟进时间',
    dataIndex: 'last_follow_time',
    width: '240px',
    key: 'last_follow_time',
    ellipsis: true,
  },
   {
    title: '预计掉保时间',
    dataIndex: 'deadline',
    width: '240px',
    key: 'deadline',
    ellipsis: true,
  }
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};
import vuedraggable from 'vuedraggable';
import { Modal } from 'ant-design-vue';
export default {
    components: {vuedraggable},
    data(){
        return{
            pageSizeOptions:['10','20','30','40','100','200'],
            select1:false,
            select2:true,
            cc1:false,
            cc2:true,
            cc3:true,
            show:false,
            tstext:"提示手机",
            data:[],
            columns,
            data2,
            columns2,
            rowSelection,
            visible:false,
            sourceObj:"",
            targetObj:"",
            pagination:{},
            currentpagination:"",
            selectedRowKeys: [],
            bgvisible:false,
            confirmLoading:false,
            bglist:"",
            bgid:"",
            importvisible:false,
            exportvisible:false,
            fileList:[],
            uploading: false,
            file:{},
            buttonshow:true,
            spinning:true,
            url:"",
            exporturl:"",
            exportload:true,
            fqvisible:false,
            reason:"",
            cause_of_abandonment:"",
            blaclist:"",
            delvisible:false,
            delid:"",
            delids:[],
            bgclueid:"",
            fqid:"",
            gjclueid:"",
            gjcontent:"",
            gjvisible:false,
            tablespinning:true,
            searchtext:"",
            size:10,
            currentpage:"",
            pageshow:false,
            totalpage:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            tabley:"",


            menulist:"",
            userinfo:"",
            search:"",
            phone:"",
            callshow:false,
            cluedetail:{
                tag:[],clue_name:""
            },
            plainOptions:[],
            tags:[],
            phoneid:"",
            typevisible:false,
            value: [],

            show1:'none',
            show2:'none',
            show3:'none',
            show4:'block',

            totalnum:"",

            searchlist:{
                status:""
            },
            current:"",
            vsearch:false,
            dxlist:{
                call_type:[],
                tag:[],
                information_source:[],
                follow_status:[],
                clue_source:[],
                gender:[],
                industry_type:[],
                enterprise_scale:[],
                position:[],
                owner:[],
                create_user_wid:[],
                last_update_user_wid:[],
                last_follow_user_wid:[],
                cause_of_abandonment:[],
                clue_status:[]
            },
            xzlist:{},
            searcharr:[],
            datelist:['昨天','今天','上周','本周','上月','本月','本季','本年'],
            datecurrent:"",
            addressoptions:[],

            simlist:[],
            currentsim:"",
            calltypelist:"",


            groupvisible:false,
            editgroupvisible:false,
            groupdetail:"",
            groupname:'',
            groupsort:"",
            grouplist:"",
            editgroupid:"",
            searchgroupname:"",
            groupnum:0,
            groupcurrent:0,
            groupid:"",
            setgroupid:"",
            setgroupvisible:false,
            groupwidth:"165px",
            groupleft:'10px',
            sgshow:true,
            zkshow:false,

            addressvalue:"",
            siptype:""
            
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){
        // 地址
        this.$axios.get('/api/getareabypid',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                res.data.data.forEach(item => {
                    this.$set(item,'isLeaf',false)

                })
                this.addressoptions=res.data.data

            }
        })
        // 获取拨打方式
        this.$axios.get("/api/getcalltype",{
        headers: {
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        }).then((res)=>{
            if(res.data.code==200){
            this.calltypelist=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        }),


        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };
        this.fetch()
        // 搜索条件
        this.$axios.get("/api/datasearch",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.searchlist=res.data.data
            }
        }),

        // 所属人列表
        this.$axios.get("/api/userlist",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.bglist=res.data.data.lists
            }
        }),
        // 标签列表
        this.$axios.get("/api/getdatatags",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.plainOptions=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        }),

        // 下载模板
        this.$axios.get("/api/getdataexcel",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.url=res.data.data.downloadurl
            }
        }),
        
        // 放弃原因
        this.$axios.get("/api/dropreason",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.reason=res.data.data
            }
        })

        this.getgrouplist()

    },
    methods:{
        // 收起分组
        sqgroup(){
            this.sgshow=false
            this.zkshow=true
            this.groupwidth=0
            this.groupleft='-154px'
        },
        zkgroup(){
            this.sgshow=true
            this.zkshow=false
            this.groupwidth='165px'
            this.groupleft='10px'
        },
        getcluebyid(value){
            if(value==0){
                this.groupid=""
            }else{
               this.groupid=value
            }
            this.groupcurrent=value
            this.fetch()
        },
        // 设置分组
        setgroupChange(value){
            this.setgroupid=value
        },
        setgroupshow(){
            this.setgroupvisible=true
        },
        setgroup(){
            this.$axios.post("/api/batchsetgroupdata",{
                   ids:this.selectedRowKeys,
                   type:1,
                   group_id:this.setgroupid
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.setgroupvisible=false
                    this.$message.fetch(res.data.msg);
                    this.fetch()
                    // this.grouplist=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 搜索分组
        searchgroup(){
            this.$axios.get("/api/searchgroupbyname",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                   type:1,
                   name:this.searchgroupname
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.grouplist=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 分组列表
        getgrouplist(){
            this.$axios.get("/api/getgrouplist",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                   type:1
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.grouplist=res.data.data
                    this.groupnum=res.data.data.length
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 新建分组
        addgroupshow(){
            this.groupvisible=true
        },
        grouphandleOk(){
            this.$axios.get("/api/addgroup",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    type:1,
                    name:this.groupname,
                    sort:this.groupsort
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.groupvisible=false
                    this.getgrouplist()

                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 编辑分组
        editgroup(value){
            this.editgroupid=value
            this.$axios.get("/api/getgroupdetail",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:value
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editgroupvisible=true
                    this.groupdetail=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        editgrouphandleOk(){
             this.$axios.get("/api/editgroup",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:this.editgroupid,
                    name:this.groupdetail.name,
                    sort:this.groupdetail.sort
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.editgroupvisible=false
                    this.getgrouplist()

                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 删除分组
        delgroup(value){

            Modal.confirm({
                title: '提示',
                content: '您确定删除此分组吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(value)
                },
                onCancel() {

                },
            });
        },
         handok(value){
            var params=new URLSearchParams()
            params.append('id',value)
            this.$axios.post('/api/delgroup',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                   this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.getgrouplist()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        lxhandleChange(value){
            this.dxlist.call_type=value
            this.fetch()
        },
        typehandleChange(value){
            this.dxlist.tag=value
            this.fetch()
        },
        lrhandleChange(value){
           this.dxlist.information_source=value
           this.fetch()
        },
        gjhandleChange(value){
            this.dxlist.follow_status=value
            this.fetch()
        },

        // 删除已选条件
        delsearch(a,b,c){
            this.searcharr=this.searcharr.filter(function (ele){return ele != a;});
            this.dxlist[b]=this.dxlist[b].filter(function (ele){return ele != c;});
            this.fetch()
        },
        deldxsearch(value){
            this.xzlist[value]=""
            this.fetch()
        },
        onChangeaddress(value){
            this.addressvalue=value
        },
        loadData(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            var id;
            if(this.addressvalue.length==1){
                id=this.addressvalue[0]
            }else{
                id=this.addressvalue[1]
            }
            this.$axios.get('/api/getareabypid',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    pid:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    if(this.value.length==1){
                        res.data.data.forEach(item => {
                        this.$set(item,'isLeaf',false)
                        })
                    }
                    targetOption.children = res.data.data
                    this.addressoptions = [...this.addressoptions];
                }
            })
        },
        changdate(value,event){
            var startime = value[0].format('YYYY-MM-DD')
            var endtime = value[1].format('YYYY-MM-DD')
            this.xzlist[event]=startime+'~'+endtime
            this.fetch()
        },
        // 选择日期
        searchdate(a,b,c){
            this.xzlist[a]=b,
            this.datecurrent=c
            this.fetch()
        },
        switchsim(e) {
            changesim(e.key)
            var qkstatus=switchstatus()
            if(qkstatus==1){
                this.currentsim=e.key
                this.$message.success("SIM"+e.key+'切卡成功');
            }else{
                this.$message.error("切卡失败")
            }
        },
        
        rselected(a,b,c){
            this.xzlist[a]=b
            // alert(this.xzlist[a])
            this.current=c;
            this.fetch()
        },
        cselected(a,b,c){
            // alert(a)
             if(this.searcharr.includes(a)){
                //includes()方法判断是否包含某一元素,返回true或false表示是否包含元素，对NaN一样有效
                //filter()方法用于把Array的某些元素过滤掉，filter()把传入的函数依次作用于每个元素，然后根据返回值是true还是false决定保留还是丢弃该元素：生成新的数组
                this.searcharr=this.searcharr.filter(function (ele){return ele != a;});
                this.dxlist[b]=this.dxlist[b].filter(function (ele){return ele != c;});
            }else{
                this.searcharr.push(a);
                this.dxlist[b].push(c)
            }
            this.fetch()
            console.log(this.xzlist[b])
        },
        cselect(){
            if(this.searchlist.status=1){
                this.searchlist.status=2
            }else{
                this.searchlist.status=1
            }
            
        },

        // 设置筛选条件
        setxmodal(){
            this.vsearch=true
        },
        setsearch(){

        },




        totel(){
            var phone=this.phone
            var type=this.siptype
            if(!phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)){
                return "请输入正确的手机号";
            }else{
                if(type==1){
                    this.$axios.get("/api/sipcall",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                        params:{
                            phone:this.phone,
                            calltype:1,
                            callsource:2
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.show6=true
                            this.show3=false
                            this.$message.success(res.data.msg);
                        }else if(res.data.code==4558){
                            this.$message.error(res.data.msg);
                        }else{
                            this.show3=false
                            this.show5=true
                            this.xglist=res.data.info
                            this.xglist2=res.data.contact_list
                            // this.$message.error(res.data.msg);
                        }
                    })
                }
            }

        },
         // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChangetype(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.post("/api/setdatatags",{
                    data_id:this.phoneid,
                    tag:this.tags
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.$axios.get("/api/getdatatags",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.plainOptions=res.data.data
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        //处理按键
        handleKeyPress(e) {
            let num = e.target.dataset.num;
            this.phone=this.phone+num
        },
        call(value,clueid){

            this.$axios.get("/api/getsipinfo",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    user_id:localStorage.getItem('userid')
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var type=res.data.data.call_methods
                    this.siptype=type
                    this.fetch()
                    console.log("type="+type)
                    if(type==2){
                        var simStatus= simlist()
                        var nowsim=currsim()  
                            if(simStatus!=undefined){
                            simStatus=simStatus.split(",")
                            }

                        for(var i in simStatus){
                        if(simStatus[i]==0){
                            this.simlist[i]=true
                        }else{
                            this.simlist[i]=false
                        }
                        } 
                        this.currentsim=nowsim

                        this.phoneid=clueid
                        // console.log("id="+this.phoneid)
                        var id=clueid
                        this.callshow=!this.callshow,
                        this.phone=value
                        var link=linktype()
                        if(link==2){
                            // alert(link)
                            this.show2='none'
                            this.show1='none'
                            this.show3='block'
                            this.show4='none'
                        }else{
                            callfixed(id,1,value)
                            this.show4='none'
                            this.show1='none'
                            this.show3='none'
                            this.show2='block'

                            this.$axios.get("/api/getdatadetail",{
                                headers: {
                                    "appid": this.appSet.appid,
                                    "appkey": this.appSet.appkey,
                                    "token":localStorage.getItem('token'),
                                },
                                params:{
                                    id:id,
                                }
                            }).then((res)=>{
                                if(res.data.code==200){
                                    this.cluedetail=res.data.data.info
                                }else{
                                    this.$message.error(res.data.msg);
                                }
                            })
                        }

                    }
                    else if(type==1){
                        this.show1='block'
                        this.show4='none'
                        this.callshow=!this.callshow,
                        this.phone=value
                        // alert(this.callshow)
                    }
                }
            })

            
            

        },
        total(){

        },
        
        closecall(){
            this.callshow=false
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            // alert(pageSize)
            this.fetch();
        },
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },

        fetch(params = {}) {
            this.loading = true;
            // console.log(this.xzlist)
            this.$axios.post('/api/getdatalist',{
                 limits: this.size,
                    page:this.currentpage,
                    name:this.searchtext,
                    clue_rang:this.xzlist.clue_rang,
                    call_type:this.dxlist.call_type,
                    tag:this.dxlist.tag,
                    information_source:this.dxlist.information_source,
                    follow_status:this.dxlist.follow_status,
                    clue_source:this.dxlist.clue_source,
                    gender:this.dxlist.gender,
                    industry_type:this.dxlist.industry_type,
                    enterprise_scale:this.dxlist.enterprise_scale,
                    position:this.dxlist.position,
                    owner:this.dxlist.owner,
                    create_user_wid:this.dxlist.create_user_wid,
                    last_update_user_wid:this.dxlist.last_update_user_wid,
                    last_follow_user_wid:this.dxlist.last_follow_user_wid,
                    cause_of_abandonment:this.dxlist.cause_of_abandonment,
                    clue_status:this.dxlist.clue_status,
                    deadline:this.xzlist.deadline,
                    birthday:this.xzlist.birthday,
                    conversion_time:this.xzlist.conversion_time,
                    create_time:this.xzlist.create_time,
                    last_update_time:this.xzlist.last_update_time,
                    last_follow_time:this.xzlist.last_follow_time,
                    pooling_time:this.xzlist.pooling_time,
                    claim_time:this.xzlist.claim_time,
                    group_id:this.groupid
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },

            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    pagination.pageSize=this.size
                    this.data=res.data.data.lists
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.count/this.size)
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 转客户
        tokh(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/cluetokh',query:{ id:id}});
        },
        // 写跟进
        showgj(event){
            this.gjclueid=event.currentTarget.id
            this.gjvisible=true
        },
        // 跟进
        gjhandleOk(){
            this.$axios.get("/api/addfollow",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    content:this.gjcontent,
                    data_id:this.gjclueid,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjvisible=false
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        // 编辑
        editclue(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/edit',query:{ id:id}});
        },
        // 删除
        delmodal(){
            this.delvisible=true
        },
        delmodal2(event){
            this.delid=event.currentTarget.id
            this.delvisible=true
        },
                
        delhandleOk(){
            if(this.delid!=""){
                this.selectedRowKeys.push(this.delid)
            }
            console.log(this.selectedRowKeys[0])
            this.$axios.post("/api/deldata",{
                'ids':this.selectedRowKeys
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.selectedRowKeys=[]
                    this.delvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        // 添加黑名单
        addblack(event){
            var phone=event.currentTarget.id

            this.$axios.get("/api/addphoneblack",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    phone:phone
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg);  
                }
            }) 
        },
        // 导出
        exportmodal(){
            this.exportvisible=true
            this.$axios.get("/api/exportdata",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.totalnum=res.data.data.total
                    this.exporturl=res.data.data.downloadurl
                }
            })
        },

        // 批量导出
        plexportmodal(){
            this.exportvisible=true
            this.$axios.post("/api/batchexport",{
                ids:this.selectedRowKeys,
                type:1
            },{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.totalnum=res.data.data.total
                    this.exporturl=res.data.data.downloadurl
                }
            })
        },
       
        // 导入数据
        importmodal(){
            this.importvisible=true
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.buttonshow=true
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            this.buttonshow=false
            return false;
        },
        importOk(){
            var formData = new FormData();
            console.log(this.fileList[0])
            var file=this.fileList[0]
            console.log(file)
            formData.append('file',file)
            console.log(formData)
            this.$axios.post("/api/importdata",formData,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    'Content-Type':'multipart/form-data',
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.importvisible=false
                    this.fetch()
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },

        handleCancel(){
            this.bgvisible=false
            this.importvisible=false
            this.exportvisible=false
            this.fqvisible=false
            this.delvisible=false
            this.gjvisible=false
            this.vsearch=false

            this.groupvisible=false
            this.editgroupvisible=false
            this.setgroupvisible=false
        },
        //放弃
        fqmodal(){
            console.log("this.fqvisible="+this.fqvisible)
            this.fqvisible=true
        },
        fqmodal2(id){
            console.log("id="+id)
            console.log(this.fqvisible)
            this.fqvisible=true
            this.fqid=id
        },
        fqreason(value){
            this.cause_of_abandonment=value
        },
        fqhandleOk(){

             if(this.fqid!=""){
                 this.selectedRowKeys.push(this.fqid)
            }
            this.$axios.post("/api/dropdata",{
                'ids':this.selectedRowKeys,
                'cause_of_abandonment':this.cause_of_abandonment
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.selectedRowKeys=[]
                    this.fqvisible=false
                    this.$message.success(res.data.msg);
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 变更所属人
        showbg(){
            this.bgvisible=true
        },
        showbg2(event){
            this.bgclueid=event.currentTarget.id
            this.bgvisible=true
        },
        bghandleChange(value){
            this.bgid=value
        },
        bghandleOk(){
            var ids;
            if(this.selectedRowKeys.length==1){
                ids=this.selectedRowKeys[0]
            }else if(this.selectedRowKeys.length>1){
                ids=this.selectedRowKeys.join(','); 
            }
            if(ids==""){
                if(this.bgclueid!=""){
                    ids=this.bgclueid
                }
            }else{
                if(this.bgclueid!=""){
                    ids=ids+','+this.bgclueid
                }
            }
            // alert(ids)
            this.$axios.get("/api/setdatabelong",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:ids,
                    user_id:this.bgid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.selectedRowKeys=[]
                    this.bgvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
            if(selectedRowKeys.length==0){
                this.cc3=true
                this.cc1=false
            }else if(selectedRowKeys.length>0){
                this.cc3=false
                this.cc1=true
            }
        },
        
        ccsearch(){
           
        },
        closecc(){
            this.cc1=false,
            this.cc2=true
        },
        handleChange(value) {
            console.log(`selected ${value}`);
        },
        handleStatus(value) {
            console.log(`selected ${value}`);
        },
        handleserach(){

        },
        handleOk(){

        },
        onChange(e){

        },
        showcc(){
             this.cc1=true,
            this.cc2=false
        },
        editlist(){
            this.visible=true
        },
        showsx(){
            this.select2=false,
            this.select1=true
        },
        setsx(){
            this.select1=false,
            this.select2=true
        },
        onSearch(){
            this.fetch()
        },

        // 拖动排序
        customRow(record, index) {
            return {
                // FIXME: draggable： true 不生效还不晓得是什么原因，先使用鼠标移入事件设置目标行的draggable属性
                props: {
                // draggable: 'true'
                },
                style: {
                cursor: 'pointer'
                },
                on: {
                // 鼠标移入
                mouseenter: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    ev.target.draggable = true
                },
                // 开始拖拽
                dragstart: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    // 阻止冒泡
                    ev.stopPropagation()
                    // 得到源目标数据
                    this.sourceObj = record
                    console.log("sourceObj="+JSON.stringify(record))
                },
                // 拖动元素经过的元素
                dragover: (event) => {
                    // 兼容 IE
                    var ev = event || window.event
                    // 阻止默认行为
                    ev.preventDefault()
                },
                // 鼠标松开
                drop: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    // 阻止冒泡
                    ev.stopPropagation()
                    // 得到目标数据
                    this.targetObj = record
                    console.log("targetObj="+JSON.stringify(record))
                }
                }
            }
        },
    }
}
</script>





// WEBPACK FOOTER //
// src/components/customer/clue.vue